var map = {
	"./E@2x.png": 172,
	"./ENE@2x.png": 173,
	"./ESE@2x.png": 174,
	"./N@2x.png": 175,
	"./NE@2x.png": 176,
	"./NNE@2x.png": 177,
	"./NNW@2x.png": 178,
	"./NW@2x.png": 179,
	"./S@2x.png": 180,
	"./SE@2x.png": 181,
	"./SSE@2x.png": 182,
	"./SSW@2x.png": 183,
	"./SW@2x.png": 184,
	"./W@2x.png": 185,
	"./WNW@2x.png": 186,
	"./WSW@2x.png": 187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;